import { i18n } from '@/plugins/i18n'

export default [
    {
        field: 'hashid',
        title: i18n.t('money_request.request_hashid'),
        sortable: true,
        width: 60,
        textAlign: 'center',
    },
    {
        field: 'user_full_name',
        title: i18n.t('money_request.user_full_name'),
        template: (row) => {
            return '<a href="/users/' + row.user_id + '/details">'+row.user_full_name+'</a>'
        },
        sortable: true,
        width: 90,
        textAlign: 'center',
    },
    {
        field: 'payer_full_name',
        title: i18n.t('money_request.payer_name'),
        sortable: true,
        width: 90,
        textAlign: 'center',
    },
    {
        field: 'amount',
        title: i18n.t('money_request.price') + " (" + i18n.t('currency.rial') + ")",
        sortable: true,
        width: 90,
        textAlign: 'center',
    },
    {
        field: 'description',
        title: i18n.t('money_request.description'),
        sortable: true,
        width: 130,
        textAlign: 'center',
    },
    {
        field: 'payment_method',
        title: i18n.t('money_request.payment_method'),
        template: (row) => {
            if (row.payment_method !== undefined) {
                const paymentMethod = moneyRequestMethod(row.payment_method);
                const variant = moneyRequestVariantColor(row.payment_method);
                return `<div class="badge ${variant}">${paymentMethod}</div>`;
            }
            return '<div class="badge badge-default">Unknown</div>';
        },
        sortable: true,
        width: 90,
        textAlign: 'center',
    },
    
    {
        field: 'created_at',
        title: i18n.t('money_request.created_at'),
        sortable: true,
        width: 90,
        textAlign: 'center',
    },
    {
        field: 'status',
        title: i18n.t('money_request.status'),
        template: (row) => {
            let status  = moneyRequestStatus(row.status)
            let variant = 'badge-'+moneyRequestVariant(row.status)

            return '<div class="badge '+variant+' text-white">'+ status+'</div>'
        },
        sortable: true,
        width: 110,
        textAlign: 'center',
    },
]

export const moneyRequestVariant = (status) => {
    if(status == '1')
        return 'success'
    if(status == '3')
        return 'danger'
    if(status == '4')
        return 'danger'
    if(status == '5')
        return 'primary'
    else
        return 'warning'
}
export const moneyRequestStatus = (status) => {
    if(status == '1')
        return i18n.t('money_request.succeed_payment')
    if(status == '3')
        return i18n.t('money_request.cancelled_payment')
    if(status == '4')
        return i18n.t('money_request.cancelled_by_admin_payment')
    if(status == '5')
        return i18n.t('money_request.paid')
    else
        return i18n.t('money_request.pending')
}
export const moneyRequestMethod = (method) => {
    if (method == '0') return i18n.t('money_request.bill_method');
    if (method == '1') return i18n.t('money_request.ipg_method');
    if (method == '2') return i18n.t('label.ipg_bill');
    return '-';
};

export const moneyRequestVariantColor = (method) => {
    if (method == '0') return 'badge-bill';
    if (method == '1') return 'badge-ipg';
    if (method == '2') return 'badge-ipg-bill';
    return 'badge-default';
};
